var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalPlaylists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7008 14.3307V35.8307C38.7008 36.2109 38.5498 36.5755 38.281 36.8443C38.0122 37.1131 37.6476 37.2641 37.2674 37.2641H5.73411C4.94291 37.2641 4.30078 36.6119 4.30078 35.8307V14.3307C4.30078 13.9506 4.45179 13.586 4.72059 13.3172C4.9894 13.0484 5.35397 12.8974 5.73411 12.8974H37.2674C38.0587 12.8974 38.7008 13.5496 38.7008 14.3307ZM35.1174 11.4641C35.3075 11.4641 35.4898 11.3886 35.6242 11.2542C35.7586 11.1198 35.8341 10.9375 35.8341 10.7474C35.8341 10.5573 35.7586 10.375 35.6242 10.2406C35.4898 10.1062 35.3075 10.0307 35.1174 10.0307H7.88411C7.69404 10.0307 7.51176 10.1062 7.37736 10.2406C7.24295 10.375 7.16745 10.5573 7.16745 10.7474C7.16745 10.9375 7.24295 11.1198 7.37736 11.2542C7.51176 11.3886 7.69404 11.4641 7.88411 11.4641H35.1174ZM32.2508 8.5974C32.4409 8.5974 32.6231 8.52189 32.7575 8.38749C32.8919 8.25309 32.9674 8.0708 32.9674 7.88073C32.9674 7.69066 32.8919 7.50837 32.7575 7.37397C32.6231 7.23957 32.4409 7.16406 32.2508 7.16406H10.7508C10.5607 7.16406 10.3784 7.23957 10.244 7.37397C10.1096 7.50837 10.0341 7.69066 10.0341 7.88073C10.0341 8.0708 10.1096 8.25309 10.244 8.38749C10.3784 8.52189 10.5607 8.5974 10.7508 8.5974H32.2508Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4706 29.4629L25.9612 25.7162C26.6635 25.365 26.6635 24.7974 25.9612 24.4462L18.4706 20.6995C17.7683 20.3483 17.1992 20.6923 17.1992 21.5022V28.6602C17.1992 29.4543 17.7668 29.8141 18.4706 29.4629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPlaylists);
export default __webpack_public_path__ + "static/media/total-playlists.770bbf63e50873ddcbb5a0ba2f342582.svg";
export { ForwardRef as ReactComponent };